/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import classNames from 'classnames';
import moment from 'moment';
import React from 'react';

const DAYS_OF_WEEK = [0, 1, 2, 3, 4, 5, 6];

/**
 * A helper component to render weekly data in datepicker
 */
export default class Week extends React.Component {
  render() {
    const { weekStartDate, dateTime, onChange, dateLimitInDays } = this.props;
    const cutOffDate = moment().subtract(dateLimitInDays, 'days');
    const currentDay = moment().date();
    const currentMonth = moment().month();
    const currentYear = moment().year();
    return (
      <tr>
        {DAYS_OF_WEEK.map(dayOfWeek => {
          let calendarDate = weekStartDate.clone().day(dayOfWeek);
          const dateOutOfRange =
            calendarDate.diff(cutOffDate) <= 0 || calendarDate > moment();
          let cellClasses = classNames({
            'slds-disabled-text': dateOutOfRange,
            'slds-is-selected': calendarDate.date() === dateTime.date(),
            'slds-is-today':
              calendarDate.date() === currentDay &&
              calendarDate.month() === currentMonth &&
              calendarDate.year() === currentYear
          });
          return (
            <td className={cellClasses} key={dayOfWeek}>
              <span
                className="slds-day"
                onClick={() => {
                  if (!dateOutOfRange) {
                    onChange(calendarDate, true);
                  }
                }}
              >
                {calendarDate.date()}
              </span>
            </td>
          );
        })}
      </tr>
    );
  }
}
